(function () {
    // Cloud Run `best-sellers` service (moved off database-app-1 2026-09-23,
    // same /get-collection-best-seller-per-country contract). Ranks fresh ROW
    // shopper sales (company-data-hub, last 12 months, by shipping country).
    // /get-low-stock-targets was NOT ported: loadTargets() below has no caller.
    var BASE_URL = 'https://best-sellers-432657747828.europe-west1.run.app';
    // var BASE_URL = 'http://127.0.0.1:5000'; // local dev

    var TARGETS_KEY_PREFIX = '__lowStockTargets:';            // sessionStorage, keyed by country (global list)
    var COLLECTION_TARGET_KEY_PREFIX = '__lowStockCollTarget:'; // sessionStorage, keyed by country:collectionId
    var CLICKED_KEY = 'SE_clickedSkus';                  // localStorage, persistent

    function _geoipFlagsFromPanel() {
        try {
            var g = window.SE_Engine
                && window.SE_Engine.config
                && window.SE_Engine.config.geoip;
            return {
                enabled: g && g.enabled === false ? '0' : '1',
                persist: g && g.persistToDatabase === false ? '0' : '1'
            };
        } catch (e) { return { enabled: '1', persist: '1' }; }
    }

    function _rankByFromPanel() {
        // Pulls rank_by from the main engine's loaded config. The engine
        // hydrates window.SE_Engine.config.bestSeller from the control
        // panel's BestSellerConfig. Defaults to 'revenue' (money
        // earned, last N months) when the config hasn't loaded yet -- matches
        // backend default. Possible values: 'qty', 'revenue'.
        try {
            var rb = window.SE_Engine
                && window.SE_Engine.config
                && window.SE_Engine.config.bestSeller
                && window.SE_Engine.config.bestSeller.rankBy;
            if (rb === 'revenue' || rb === 'qty') return rb;
        } catch (e) { /* swallow */ }
        return 'revenue';
    }

    // ── Activation-mode gate (kept in sync with best-seller-toast.js) ────
    // BOTH best-seller pipelines (this file + best-seller-toast.js) share
    // the SAME localStorage key so first-collection-only mode actually
    // means "one activation EVER, across both fetchers". Without this gate
    // in priority-products too, the user sees one activation per collection
    // because EACH collection page fires priority-products' own fetch
    // independent of best-seller-toast.js's gate.
    var BS_LOCAL_KEY = '__bestSellerActivationsLocal';

    function _readBsActivations() {
        try {
            var raw = localStorage.getItem(BS_LOCAL_KEY);
            if (!raw) return [];
            var arr = JSON.parse(raw);
            return Array.isArray(arr) ? arr : [];
        } catch (e) { return []; }
    }

    function _writeBsActivation(collectionId, sku, handle) {
        try {
            var cid = String(collectionId || '');
            var arr = _readBsActivations();
            // Upsert: drop any prior entry for the same collectionId so
            // the pre-flight placeholder gets replaced by the post-fetch
            // entry that carries the real sku/handle.
            arr = arr.filter(function (e) { return e && e.collectionId !== cid; });
            arr.push({
                collectionId: cid,
                sku: String(sku || ''),
                handle: String(handle || ''),
                at: Date.now()
            });
            localStorage.setItem(BS_LOCAL_KEY, JSON.stringify(arr));
        } catch (e) {}
    }

    function _hasAnyBsActivation() {
        // PRIMARY signal: dedicated localStorage key. Survives engine
        // state-restore wipes that race with rapid collection navigation.
        try {
            // Only a REAL activation (an entry that carries a sku) raises the global
            // first-collection gate. The pre-flight write below stamps an EMPTY-sku
            // placeholder BEFORE the network call; counting it here let a collection
            // with NO best-seller (or a failed fetch) permanently lock the gate — and
            // this key is SHARED with best-seller-toast.js, so it blocked both pipelines.
            // Empty placeholders are ignored; the gate locks only on a true activation.
            var _bs = _readBsActivations();
            for (var _bi = 0; _bi < _bs.length; _bi++) {
                if (_bs[_bi] && _bs[_bi].sku) return true;
            }
        } catch (e) {}
        // SECONDARY: engine state (populated by best-seller-toast.js or
        // restored from group state via session match identify).
        try {
            var eng = window.SE_Engine;
            if (!eng || !eng.state) return false;
            var map = eng.state.bestSellerCollections || {};
            for (var k in map) {
                if (Object.prototype.hasOwnProperty.call(map, k) && map[k]) return true;
            }
            var handles = eng.state.bestSellerHandles;
            if (Array.isArray(handles) && handles.length > 0) return true;
            return false;
        } catch (e) { return false; }
    }

    // One-time cleanup: strip EMPTY-sku placeholders left in the SHARED BS_LOCAL_KEY
    // by the pre-flight write when a non-triggering / failed first collection used to
    // leave an empty entry that wrongly locked the first-collection gate (for BOTH this
    // pipeline and best-seller-toast.js). The gate above now ignores empty entries;
    // purge them so an already-polluted browser self-heals. Idempotent.
    (function _purgeEmptyBsPlaceholders() {
        try {
            var arr = _readBsActivations();
            var cleaned = arr.filter(function (e) { return e && e.sku; });
            if (cleaned.length !== arr.length) {
                localStorage.setItem(BS_LOCAL_KEY, JSON.stringify(cleaned));
            }
        } catch (e) {}
    })();

    function _activationModeFromPanel() {
        try {
            var m = window.SE_Engine
                && window.SE_Engine.config
                && window.SE_Engine.config.bestSeller
                && window.SE_Engine.config.bestSeller.activationMode;
            if (m === 'every-collection' || m === 'first-collection-only') return m;
        } catch (e) { /* swallow */ }
        return 'first-collection-only';
    }

    // ── persistence helpers ──────────────────────────────────────────────
    function readCountry() {
        try { return (localStorage.getItem('country') || '').trim(); } catch (e) { return ''; }
    }
    function readCachedTargets(country) {
        try {
            var raw = sessionStorage.getItem(TARGETS_KEY_PREFIX + country);
            return raw ? JSON.parse(raw) : null;
        } catch (e) { return null; }
    }
    function writeCachedTargets(country, list) {
        try { sessionStorage.setItem(TARGETS_KEY_PREFIX + country, JSON.stringify(list)); } catch (e) {}
    }
    function getClickedSkus() {
        try {
            var raw = localStorage.getItem(CLICKED_KEY);
            var arr = raw ? JSON.parse(raw) : [];
            return Array.isArray(arr) ? arr : [];
        } catch (e) { return []; }
    }
    function addClickedSku(sku) {
        var arr = getClickedSkus();
        if (arr.indexOf(sku) === -1) arr.push(sku);
        try { localStorage.setItem(CLICKED_KEY, JSON.stringify(arr)); } catch (e) {}
        window.__SE_count = arr.length;
    }
    window.__SE_count = getClickedSkus().length;

    // ── current-collection detection ─────────────────────────────────────
    // theme.liquid emits these globals on every collection page:
    //   window.__currentCollectionId      (numeric Shopify ID)
    //   window.__currentCollectionHandle  (string handle)
    // The inline <script> that sets them runs BEFORE this file (which is
    // deferred), so by the time we read them they're populated. URL
    // fallback covers edge cases where the inline didn't fire.
    function readCurrentCollection() {
        try {
            var id = window.__currentCollectionId;
            var handle = window.__currentCollectionHandle;
            if (id || handle) {
                return { id: id ? String(id) : '', handle: handle ? String(handle) : '' };
            }
        } catch (e) {}
        var m = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
        if (m && m[1] && m[1] !== 'all') return { id: '', handle: m[1] };
        return null;
    }

    // ── per-collection target loader ─────────────────────────────────────
    // On a collection page we always want THIS collection's best-seller,
    // even if the collection isn't in the configured global target list
    // (e.g. "Combat Gear"). Cache key is (country, collectionId) so the
    // first-collection-clicked doesn't poison subsequent collection pages.
    //
    // Returns a target shaped like the global-list entries
    // ({collection_handle, product_name, variant_sku}) so applyBadgeForTarget
    // can consume both flows uniformly.
    function readCachedCollectionTarget(country, collectionKey) {
        // Three states matter:
        //   undefined = cache miss, never been set this session    (fetch)
        //   null      = cached "backend said no best-seller here"  (don't refetch)
        //   object    = cached target                              (use it)
        try {
            var raw = sessionStorage.getItem(COLLECTION_TARGET_KEY_PREFIX + country + ':' + collectionKey);
            if (raw === null) return undefined;
            return JSON.parse(raw);
        } catch (e) { return undefined; }
    }
    function writeCachedCollectionTarget(country, collectionKey, target) {
        try {
            sessionStorage.setItem(
                COLLECTION_TARGET_KEY_PREFIX + country + ':' + collectionKey,
                JSON.stringify(target)
            );
        } catch (e) {}
    }

    async function loadCollectionTarget(country, collection) {
        if (!collection || !collection.id) return null;
        var cacheCountry = country || '__unknown__';
        var collectionKey = collection.id;

        var cached = readCachedCollectionTarget(cacheCountry, collectionKey);
        if (cached !== undefined) return cached;

        // ACTIVATION GATE: shared with best-seller-toast.js via BS_LOCAL_KEY.
        // Under first-collection-only mode (panel default), once ANY collection
        // has fired a best-seller activation (either pipeline), every subsequent
        // collection skips its fetch. Without this gate, priority-products would
        // fire one fetch per collection independent of best-seller-toast.js's
        // gate -- which is exactly the "still per-collection" bug reported.
        if (_activationModeFromPanel() === 'first-collection-only'
            && _hasAnyBsActivation()) {
            try {
                /* diagnostic removed */
            } catch (e) {}
            // Cache null so we don't re-check the gate on subsequent calls
            // (the bestSeller-toast.js replay path handles re-applying the
            // existing badge on this page).
            writeCachedCollectionTarget(cacheCountry, collectionKey, null);
            return null;
        }
        // PRE-FLIGHT GATE LOCK: stamp BEFORE the network call so a rapid
        // navigation mid-fetch (Render cold-start is 1-3s; shoppers click
        // through collections faster than that) doesn't let collection #2
        // see an empty gate while collection #1's fetch is still in flight.
        // The placeholder gets upserted with the real sku/handle on success.
        try {
            _writeBsActivation(collection.id, '', '');
            /* diagnostic removed */
        } catch (e) {}

        try {
            var qsParts = ['collection_id=' + encodeURIComponent(collection.id)];
            if (country) qsParts.push('country=' + encodeURIComponent(country));
            try {
                var vid = localStorage.getItem('visitorID');
                if (vid) qsParts.push('visitorID=' + encodeURIComponent(vid));
            } catch (e) {}
            qsParts.push('rank_by=' + encodeURIComponent(_rankByFromPanel()));
            var _g = _geoipFlagsFromPanel();
            qsParts.push('region_enabled=' + _g.enabled);
            qsParts.push('region_persist=' + _g.persist);
            var url = BASE_URL + '/get-collection-best-seller-per-country?' + qsParts.join('&');
            var res = await fetch(url);
            if (!res.ok) {
                writeCachedCollectionTarget(cacheCountry, collectionKey, null);
                return null;
            }
            var data = await res.json();
            // Endpoint returns DataFrame.to_json(orient='records') -> array.
            // #1 best-seller is the first row.
            var record = Array.isArray(data) && data.length ? data[0] : null;
            if (!record) {
                writeCachedCollectionTarget(cacheCountry, collectionKey, null);
                return null;
            }
            // Normalize to the shape applyBadgeForTarget expects. The
            // collection_handle isn't in the analytics rows; we know it from
            // the page context (theme.liquid set __currentCollectionHandle).
            var target = {
                collection_handle: collection.handle || '',
                product_name: record.product_name || record.name || null,
                variant_sku: record.variant_sku || record.sku || null
            };
            writeCachedCollectionTarget(cacheCountry, collectionKey, target);
            // Upsert the real activation into the shared gate key. Replaces
            // the pre-flight placeholder with the real sku so subsequent
            // pages can see "what was activated, where".
            try {
                _writeBsActivation(collection.id, target.variant_sku || '', '');
                // Mirror into engine state so best-seller-toast.js's replay
                // path (_applyPersistedBestSellerBadges) re-stamps on later
                // pages and the activation survives across browsing sessions
                // via the engine's saveState() -> backend sync.
                try {
                    var eng = window.SE_Engine;
                    if (eng) {
                        if (!eng.state) eng.state = {};
                        if (!eng.state.bestSellerCollections) eng.state.bestSellerCollections = {};
                        eng.state.bestSellerCollections[String(collection.id)] = {
                            sku: target.variant_sku || '',
                            activatedAt: Date.now()
                        };
                        if (typeof eng._scheduleStateSync === 'function') eng._scheduleStateSync();
                    }
                } catch (e) {}
                /* diagnostic removed */
            } catch (e) {}
            return target;
        } catch (e) { return null; }
    }

    // ── load targets (per-country session cache, then backend) ──────────
    async function loadTargets() {
        var country = readCountry();
        // Step 1 — country missing? Backend will IP-resolve when we send no param.
        // (Cache key in that case uses '__unknown__' so we re-fetch once country lands.)
        var cacheCountry = country || '__unknown__';

        var cached = readCachedTargets(cacheCountry);
        if (cached) return cached;

        try {
            // Build query string: send country (if known, the user-told value)
            // and visitorID (so the backend can persist IP-derived country into
            // user.country_detected for the next session).
            var qsParts = [];
            if (country) qsParts.push('country=' + encodeURIComponent(country));
            try {
                var vid = localStorage.getItem('visitorID');
                if (vid) qsParts.push('visitorID=' + encodeURIComponent(vid));
            } catch (e) {}
            qsParts.push('rank_by=' + encodeURIComponent(_rankByFromPanel()));
            var _g2 = _geoipFlagsFromPanel();
            qsParts.push('region_enabled=' + _g2.enabled);
            qsParts.push('region_persist=' + _g2.persist);
            var qs = qsParts.length ? ('?' + qsParts.join('&')) : '';
            var res = await fetch(BASE_URL + '/get-low-stock-targets' + qs);
            if (!res.ok) return null;
            var data = await res.json();
            if (!Array.isArray(data)) return null;
            writeCachedTargets(cacheCountry, data);
            return data;
        } catch (e) { return null; }
    }

    // ── DOM helpers ──────────────────────────────────────────────────────
    // Only the real Prestige <product-card> elements on collection / search /
    // featured grids count as cards. Everything else (mini-cart line items,
    // predictive search suggestions, header drawers, recently-viewed strips
    // inside dialogs) gets explicitly rejected so badges don't follow the
    // product into menus or drawers.
    // `product-recommendations` (Shopify's algorithmic complementary "pairs well
    // with" + related "you may also like" rails — see complementary-products.liquid)
    // is excluded so a recommended/low product does NOT get its LOW ON STOCK badge
    // re-stamped onto every cross-sell carousel it appears in across the site (the
    // "almost always low stock" leak — 2026-06-03). Low-stock belongs on the
    // browsing grid + the product's own PDP, never on cross-sell thumbnails.
    var CARD_EXCLUDE_ANCESTORS = 'cart-drawer, predictive-search, header, footer, dialog, [role="dialog"], aside, product-recommendations';
    function _closestCard(el) {
        var card = el.closest('product-card');
        if (!card) return null;
        if (card.closest(CARD_EXCLUDE_ANCESTORS)) return null;
        return card;
    }
    // Dedup against badges already on the card — main engine,
    // merchant metafield, or our own earlier run.
    function _hasLowStockBadge(card) {
        if (card.querySelector('.badge--low-stock')) return true;
        var badges = card.querySelectorAll('.badge');
        for (var i = 0; i < badges.length; i++) {
            var txt = (badges[i].textContent || '').trim().toUpperCase();
            if (txt === 'LOW STOCK' || txt === 'LOW ON STOCK') return true;
        }
        return false;
    }

    // A sold-out product card carries Prestige's <sold-out-badge> (rendered by
    // product-badges.liquid, visible only when the product's first-available
    // variant is unavailable). Never stack LOW ON STOCK on a SOLD OUT card.
    function _isSoldOut(card) {
        try {
            return !!(card && card.querySelector('sold-out-badge:not([hidden]), .badge--sold-out:not([hidden])'));
        } catch (e) { return false; }
    }

    function _badgePositionFromConfig() {
        var fallback = {
            anchor: 'top-left',
            offsetVerticalRem: 0.25,
            offsetHorizontalRem: 0.25,
            zIndex: 1
        };
        try {
            var bp = window.SE_Engine
                && window.SE_Engine.config
                && window.SE_Engine.config.bestSeller
                && window.SE_Engine.config.bestSeller.badgePosition;
            if (!bp) return fallback;
            var validAnchors = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
            return {
                anchor: validAnchors.indexOf(bp.anchor) !== -1 ? bp.anchor : fallback.anchor,
                offsetVerticalRem:   Number.isFinite(bp.offsetVerticalRem)   ? bp.offsetVerticalRem   : fallback.offsetVerticalRem,
                offsetHorizontalRem: Number.isFinite(bp.offsetHorizontalRem) ? bp.offsetHorizontalRem : fallback.offsetHorizontalRem,
                zIndex:              Number.isFinite(bp.zIndex)              ? bp.zIndex              : fallback.zIndex
            };
        } catch (e) { return fallback; }
    }
    function _applyBadgePosition(span, pos) {
        span.style.position = 'absolute';
        // Reset every edge so changing anchor at runtime doesn't leave a
        // stale opposite-side value pinning the badge.
        span.style.top = span.style.bottom = span.style.left = span.style.right = '';
        if (pos.anchor === 'top-left') {
            span.style.top  = pos.offsetVerticalRem   + 'rem';
            span.style.left = pos.offsetHorizontalRem + 'rem';
        } else if (pos.anchor === 'top-right') {
            span.style.top   = pos.offsetVerticalRem   + 'rem';
            span.style.right = pos.offsetHorizontalRem + 'rem';
        } else if (pos.anchor === 'bottom-left') {
            span.style.bottom = pos.offsetVerticalRem   + 'rem';
            span.style.left   = pos.offsetHorizontalRem + 'rem';
        } else { // bottom-right
            span.style.bottom = pos.offsetVerticalRem   + 'rem';
            span.style.right  = pos.offsetHorizontalRem + 'rem';
        }
        span.style.zIndex = String(pos.zIndex);
    }

    // Single badge per card. Theme classes for visual styling (same colors,
    // font, padding as the main engine and merchant badges). Position
    // is driven by the panel config (BestSellerConfig.badgePosition);
    // defaults to top-left at 0.25rem from each edge, z-index 1 -- theme
    // parity with the native badge-list rule (theme.css:2150).
    function _addBadge(card, sku, source) {
        if (_hasLowStockBadge(card)) return;
        if (_isSoldOut(card)) return; // never LOW ON STOCK on a sold-out product
        var span = document.createElement('span');
        span.className = 'badge badge--custom badge--low-stock';
        // ALWAYS "LOW ON STOCK" — the SAME wording every low-stock workflow uses
        // (new-user / best-seller / returning predicted-next). The per-variant
        // unit count ("only N left") belongs to the VARIANT on the PDP, never the
        // grid/card badge.
        span.textContent = ((window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.stockBadge && !/^translation missing/i.test(window.themeVariables.strings.stockBadge)) ? String(window.themeVariables.strings.stockBadge).toUpperCase() : 'LOW ON STOCK'); // agilite_stock.badge, 2026-10-05
        // Neutralized OPAQUE source codes (legend in cae-client mapping + panel/
        // doc 09): 'd' = best-seller, 'c' = returning predicted-next reco. Matches
        // the engine's scheme (a=real, b=synthetic, c=return reco) so the DOM stamp
        // never leaks a descriptive value. Default 'd' (best-seller path); the
        // returning teaser caller passes 'c'. cae maps both back to readable names.
        span.dataset.lowStockSource = source || 'd';
        if (sku) span.dataset.sourceSku = sku;
        _applyBadgePosition(span, _badgePositionFromConfig());
        span.style.pointerEvents = 'none';
        var anchor = card.querySelector('.product-card__figure') || card;
        var cs = window.getComputedStyle(anchor);
        if (cs && cs.position === 'static') anchor.style.position = 'relative';
        anchor.appendChild(span);
    }

    // ── SKU -> product handle (within the target's own collection) ───────
    //
    // Two caching layers + in-flight dedup:
    //   - sessionStorage __lowStockHandleCache : persists across page navs
    //     in the same tab so each (collection_handle/products.json) fetch
    //     happens at most ONCE per session, not once per page load.
    //   - _handlePromises : if two parallel calls ask for the same SKU
    //     simultaneously, only one network request fires; the second await
    //     piggybacks on the first promise.
    var HANDLE_CACHE_KEY = '__lowStockHandleCache';
    function _readHandleCache() {
        try {
            var raw = sessionStorage.getItem(HANDLE_CACHE_KEY);
            var obj = raw ? JSON.parse(raw) : {};
            return (obj && typeof obj === 'object') ? obj : {};
        } catch (e) { return {}; }
    }
    function _writeHandleCache(cache) {
        try { sessionStorage.setItem(HANDLE_CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
    }
    var _handleCache = _readHandleCache();
    var _handlePromises = {};

    async function resolveProductHandleForTarget(target) {
        var sku = target.variant_sku;
        if (!sku) return null;
        if (_handleCache.hasOwnProperty(sku)) return _handleCache[sku]; // null = "definitely not found"
        if (_handlePromises[sku]) return _handlePromises[sku];          // in-flight, reuse
        if (!target.collection_handle) return null;

        _handlePromises[sku] = (async function () {
            var resolved = null;
            try {
                var url = '/collections/' + encodeURIComponent(target.collection_handle) + '/products.json?limit=250';
                var res = await fetch(url);
                if (!res.ok) return null;
                var data = await res.json();
                var prods = data.products || [];
                for (var i = 0; i < prods.length; i++) {
                    var variants = prods[i].variants || [];
                    for (var j = 0; j < variants.length; j++) {
                        if (variants[j].sku === sku) {
                            resolved = prods[i].handle;
                            return resolved;
                        }
                    }
                }
                // SKU fallback: name match
                if (target.product_name) {
                    for (var k = 0; k < prods.length; k++) {
                        if (prods[k].title === target.product_name) {
                            resolved = prods[k].handle;
                            return resolved;
                        }
                    }
                }
                return null;
            } catch (e) { return null; }
            finally {
                // Persist whatever we found (or null) so subsequent calls
                // in this session don't repeat the fetch — even for misses.
                _handleCache[sku] = resolved;
                _writeHandleCache(_handleCache);
                delete _handlePromises[sku];
            }
        })();
        return _handlePromises[sku];
    }

    // Bundles -> components map. KEPT IN SYNC with the main engine's
    // version at favorite-color-variant-picker.js:241 (which itself
    // mirrors BUNDLE_DATA_RAW in agb-bundles.js). When a best-seller fires
    // for a component product, we also badge every bundle that contains
    // it — same semantics the main engine uses for low-stock
    // bundle propagation.
    var BUNDLE_COMPONENT_MAP = {
        'k-zero-bundle':                                                          ['k-zero-plate-carrier', 'pincer-placard', 'six-pack-hanger-pouch'],
        'k-zero-test-bundle':                                                     ['k-zero-plate-carrier', 'pincer-placard', 'six-pack-hanger-pouch'],
        'k-zero-sf-bundle':                                                       ['k-zero-sf-plate-carrier', 'pincer-placard', 'six-pack-hanger-pouch'],
        'k-zero-plate-carrier-with-level-4-plates-2-x-level-4-warrior-plates':    ['k-zero-plate-carrier'],
        'k-zero-plate-carrier-with-plates-level-3st':                             ['k-zero-plate-carrier'],
        'k-zero-sf-plate-carrier-with-level-4-plates-2-x-level-4-warrior-plates': ['k-zero-sf-plate-carrier'],
        'k-zero-sf-plate-carrier-with-plates-2-x-level-3st-protector-plates':     ['k-zero-sf-plate-carrier'],
        'sub-zero-plate-carrier-with-2-protector-level-3st-armor-plates':         ['sub-zero-plate-carrier'],
        'reaper-rig-micro-rig-bundle':                                            ['reaper-chest-rig', 'pincer-placard', 'six-pack-hanger-pouch'],
        'sub-zero-ranger-green-bundle':                                           ['sub-zero-plate-carrier', 'ag3-placard-triple-mag-pouch', 'six-pack-hanger-pouch'],
        'sub-zero-multicam-bundle':                                               ['sub-zero-plate-carrier', 'ag3-placard-triple-mag-pouch', 'wide-admin-pouch'],
        'sub-zero-black-bundle':                                                  ['sub-zero-plate-carrier', 'ag3-placard-triple-mag-pouch', 'six-pack-hanger-pouch']
    };
    function bundlesContainingComponent(componentHandle) {
        if (!componentHandle) return [];
        var hits = [];
        for (var bundleHandle in BUNDLE_COMPONENT_MAP) {
            if (!Object.prototype.hasOwnProperty.call(BUNDLE_COMPONENT_MAP, bundleHandle)) continue;
            var components = BUNDLE_COMPONENT_MAP[bundleHandle];
            if (Array.isArray(components) && components.indexOf(componentHandle) !== -1) {
                hits.push(bundleHandle);
            }
        }
        return hits;
    }

    // ── UNIFIED low-stock badge + bundle propagation ─────────────────────
    // ONE entry point every targeting workflow (best-seller, returning
    // predicted-next) calls, so bundle propagation can't drift / regress per
    // workflow. Metadata-driven via window.Catalog (custom.bundle_main_product /
    // custom.included_in_bundles, emitted server-side by catalog-data-emit.liquid)
    // with the static BUNDLE_COMPONENT_MAP as the offline fallback. NO network /
    // JSON scraping. Mirrors the engine's _lowStockHandlesForCard rules:
    //   • forward: a low product makes EVERY bundle it's part of low too.
    //   • reverse: a low bundle makes its MAIN product low too (main only).

    // Bundles whose MAIN product is `handle` — the forward set, MAIN-ONLY (rule:
    // a bundle/loadout goes low ONLY when its MAIN product is low; a shared
    // accessory component — six-pack-hanger-pouch, pincer-placard, … — going low
    // must NOT light every loadout it appears in). Mirrors the engine's
    // _bundlesWhereMainComponent. When `colorSlug` is given, COLOR-GATE the result
    // the SAME way the engine's Pass 1 does: a colored bundle stays only if its
    // handle's color token matches `colorSlug`; colorless bundles always pass —
    // reusing SE_Engine._extractColorFromBundleHandle. Omit colorSlug → no filter.
    function bundlesForComponent(handle, colorSlug) {
        var out = [];
        if (!handle) return out;
        try {
            if (window.Catalog && typeof window.Catalog.includedInBundles === 'function'
                && typeof window.Catalog.mainProductOf === 'function') {
                var bs = window.Catalog.includedInBundles(handle) || [];
                bs.forEach(function (b) {
                    var bh = (typeof b === 'string') ? b : (b && (b.bundleHandle || b.handle));
                    // keep ONLY bundles whose MAIN product is `handle` (not any-position membership)
                    if (bh && out.indexOf(bh) === -1 && window.Catalog.mainProductOf(bh) === handle) out.push(bh);
                });
            }
        } catch (e) {}
        // Static-map fallback: a bundle's MAIN is components[0]; keep only bundles
        // whose FIRST component is `handle`, never an accessory at a later position.
        try {
            for (var bundleHandle in BUNDLE_COMPONENT_MAP) {
                if (!Object.prototype.hasOwnProperty.call(BUNDLE_COMPONENT_MAP, bundleHandle)) continue;
                var comps = BUNDLE_COMPONENT_MAP[bundleHandle];
                if (Array.isArray(comps) && comps.length && comps[0] === handle && out.indexOf(bundleHandle) === -1) {
                    out.push(bundleHandle);
                }
            }
        } catch (e) {}
        if (colorSlug) {
            try {
                var E = window.SE_Engine;
                if (E && typeof E._extractColorFromBundleHandle === 'function') {
                    out = out.filter(function (bh) {
                        var bc = E._extractColorFromBundleHandle(bh); // null for colorless bundles
                        return !bc || bc === colorSlug;
                    });
                }
            } catch (e) {}
        }
        return out;
    }

    // Badge the ONE real grid card whose OWN handle === `h` (never climbs to a
    // bundle card that merely links to it). Page-wide deduped via _badgedHandles.
    function _badgeCardByHandle(h, sku, source) {
        if (!h || _badgedHandles.has(h)) return false;
        var cards = document.querySelectorAll('product-card[handle="' + h + '"], .product-card[handle="' + h + '"]');
        for (var j = 0; j < cards.length; j++) {
            if (cards[j].closest(CARD_EXCLUDE_ANCESTORS)) continue;
            _addBadge(cards[j], sku, source);
            var lk = cards[j].querySelector('a[href*="/products/"]');
            if (lk) _attachClickTracker(lk, sku);
            _badgedHandles.add(h);
            return true;
        }
        return false;
    }

    // THE shared low-stock badging entry point — identical "LOW ON STOCK" badge
    // for every workflow (best-seller + returning predicted-next). Badges the
    // product's own card + propagates bidirectionally across bundles. Returns
    // true if the product's OWN card was badged (callers use it for their cap).
    function badgeProductWithBundles(handle, sku, colorSlug, source) {
        if (!handle) return false;
        // never badge a DEAD product: its workflow ran and finished and the
        // engine refuses to ever start another (exhausted has no bypass) -
        // the badge would promise urgency the PDP can never show again.
        // Engine absent -> fail open (badge as before).
        try {
            var _E = window.SE_Engine;
            if (_E && typeof _E.isProductExhausted === 'function'
                && _E.isProductExhausted(handle)) return false;
        } catch (e) { /* fail open */ }
        var badgedOwn = _badgeCardByHandle(handle, sku, source);
        // forward: low product → every bundle it's part of is low too (color-gated
        // when colorSlug is supplied, so only the matching-color bundle lights up).
        var bundles = bundlesForComponent(handle, colorSlug);
        for (var b = 0; b < bundles.length; b++) _badgeCardByHandle(bundles[b], sku, source);
        // reverse: if the target itself IS a bundle, its MAIN product is low too.
        try {
            if (window.Catalog && typeof window.Catalog.isBundle === 'function'
                && window.Catalog.isBundle(handle)
                && typeof window.Catalog.mainProductOf === 'function') {
                var main = window.Catalog.mainProductOf(handle);
                if (main) _badgeCardByHandle(main, sku, source);
            }
        } catch (e) {}
        return badgedOwn;
    }

    // Page-wide dedup: at most ONE badge per product handle on the page,
    // regardless of how many cards link to that product (featured row +
    // main grid + cross-sell etc.). Shared with best-seller-toast.js via
    // window so both systems agree on what's been badged this page load.
    window._AGB_badgedHandles = window._AGB_badgedHandles || new Set();
    var _badgedHandles = window._AGB_badgedHandles;

    async function applyBadgeForTarget(target) {
        // Collection-grid only — never on PDP, search results, mini-cart, etc.
        if (window.location.pathname.indexOf('/products/') === 0) return;
        var productHandle = await resolveProductHandleForTarget(target);
        if (!productHandle) return;
        if (_badgedHandles.has(productHandle)) return;

        // Badge the best-seller product + propagate across its bundles (forward
        // + reverse) via the SINGLE shared low-stock path, so best-seller and the
        // returning predicted-next flow can never drift. Metadata-driven
        // (window.Catalog), no JSON scraping. No `count` ⇒ "LOW ON STOCK".
        var badged = badgeProductWithBundles(productHandle, target.variant_sku);
        try {
            /* diagnostic removed */
        } catch (e) {}
    }

    // Walk every product-card on the page (excluding drawers/dialogs) and
    // badge any whose handle starts with `componentHandle + "-"`. This
    // matches handle-stem conventions like:
    //   magnetix-battle-belt              <-- the component itself (skipped)
    //   magnetix-battle-belt-loadout      <-- bundle variant of component
    //   magnetix-battle-belt-loadout-multicam
    //   sub-zero-plate-carrier-with-...
    // Dedup against _badgedHandles so we don't double-badge a card already
    // hit by the map-based or name-keyword paths.
    function badgeCardsByHandleStem(componentHandle, sku, count) {
        if (!componentHandle) return 0;
        var prefix = componentHandle + '-';
        var added = 0;
        var cards = document.querySelectorAll('product-card[handle]');
        for (var i = 0; i < cards.length; i++) {
            var card = cards[i];
            // Exclude cards inside drawers / dialogs / mini-cart etc.
            if (card.closest(CARD_EXCLUDE_ANCESTORS)) continue;
            var h = card.getAttribute('handle');
            if (!h) continue;
            if (h === componentHandle) continue;        // skip the component itself
            if (h.indexOf(prefix) !== 0) continue;       // must start with "<component>-"
            if (_badgedHandles.has(h)) continue;
            _addBadge(card, sku);
            _badgedHandles.add(h);
            var linkEl = card.querySelector('a[href*="/products/"]');
            if (linkEl) _attachClickTracker(linkEl, sku);
            added++;
        }
        return added;
    }

    function _normalizeName(s) {
        return (s || '').toLowerCase()
            .replace(/^agilite[\s™®©]*/i, '')
            .replace(/[™®©]/g, '')
            .replace(/[^\w\s]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }
    function badgeBundlesByName(productName, sku) {
        var needle = _normalizeName(productName);
        if (!needle) return 0;
        var added = 0;
        // Same tight selector as _closestCard — only real product-cards,
        // never inside drawers/search/etc.
        var titles = document.querySelectorAll('product-card h1, product-card h2, product-card h3');
        titles.forEach(function (t) {
            var text = _normalizeName(t.textContent || '');
            if (text.indexOf(needle) === -1) return;
            if (!/\b(bundle|package|loadout|kit)\b/.test(text)) return;
            var card = _closestCard(t);
            if (!card) return;
            // Find the bundle's own product handle from its product-card
            // attribute (or its link). Dedup by handle so the same bundle
            // appearing in two grids only gets one badge.
            var bundleHandle = card.getAttribute('handle');
            if (!bundleHandle) {
                var link = card.querySelector('a[href*="/products/"]');
                var match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
                bundleHandle = match ? match[1] : null;
            }
            if (bundleHandle && _badgedHandles.has(bundleHandle)) return;
            _addBadge(card, sku);
            if (bundleHandle) _badgedHandles.add(bundleHandle);
            var linkEl = card.querySelector('a[href*="/products/"]');
            if (linkEl) _attachClickTracker(linkEl, sku);
            added++;
        });
        return added;
    }

    // sessionStorage key that the main engine
    // (favorite-color-variant-picker.js) reads to know "this shopper
    // arrived on the PDP via a best-seller badge click". When the
    // destination handle is in this list, the engine allows N extra
    // lifecycles per product beyond the normal cap (see
    // `bestSellerExtraLifecyclesPerProduct` in the control panel).
    var BEST_SELLER_ARRIVALS_KEY = '__bestSellerArrivals';

    function _recordBestSellerArrival(href) {
        if (!href) return;
        var m = href.match(/\/products\/([^/?#]+)/);
        if (!m) return;
        var handle = m[1];
        try {
            var raw = sessionStorage.getItem(BEST_SELLER_ARRIVALS_KEY);
            var arr = raw ? JSON.parse(raw) : [];
            if (!Array.isArray(arr)) arr = [];
            if (arr.indexOf(handle) === -1) {
                arr.push(handle);
                sessionStorage.setItem(BEST_SELLER_ARRIVALS_KEY, JSON.stringify(arr));
            }
        } catch (e) {}
    }

    function _attachClickTracker(linkEl, sku) {
        if (linkEl.__lowStockTrackerAttached) return;
        linkEl.__lowStockTrackerAttached = true;
        linkEl.addEventListener('click', function () {
            addClickedSku(sku);
            // Mark the destination product handle as a best-seller arrival
            // so the main engine can allow extra lifecycles for it.
            _recordBestSellerArrival(linkEl.getAttribute('href'));
        }, { capture: true });
    }

    // ── returning-user predicted-next targeting (step 4b) ────────────────
    // For the returning-user flow ONLY, badge the shopper's predicted-next
    // products (localStorage.recommendedProducts, entries keyed by productLink)
    // on the current collection grid — focusing the low-stock signal on what
    // they're likely to buy next. Reuses the best-seller badge machinery
    // (_addBadge / _closestCard / _badgedHandles), capped so it never floods,
    // deduped against best-seller badges. Inert for new/campaign users + when
    // no recs are cached. Gated on window.__userFlow (set by user-flow-gate.js).
    function _badgeRecommendedForReturning() {
        try {
            if (typeof window === 'undefined' || window.__userFlow !== 'returning-user') return;
            var raw = localStorage.getItem('recommendedProducts');
            if (!raw) return;
            var recs = JSON.parse(raw);
            if (!Array.isArray(recs) || !recs.length) return;
            // predicted-next is a focus, not a grid takeover. Cap is config-driven
            // (SE_Engine.config.profiles.returningUser.predictedNextBadgeCap); falls
            // back to 2 when the engine/config is absent or the value is invalid.
            var E = window.SE_Engine;
            var profile = (E && E.config && E.config.profiles && E.config.profiles.returningUser) || null;
            var cfgCap = profile && profile.predictedNextBadgeCap;
            var CAP = (typeof cfgCap === 'number' && isFinite(cfgCap) && cfgCap >= 0) ? cfgCap : 2;
            // NEW returning model: a product the shopper has already CLICKED into carries
            // a real lifecycle and shows its LOW ON STOCK badge via the engine's lifecycle
            // reveal (applyCollectionLowStockBadges) — we do NOT re-badge those here, and
            // we START NO LIFECYCLE here. We only draw TEASER badges (no lifecycle) on
            // not-yet-clicked recommended products to FILL the remaining slots up to CAP.
            // So once CAP products are triggered, teaserBudget hits 0 → the un-clicked
            // recommended products get NO teaser badge (they're "removed" on this render).
            var triggered = (E && E._returningProductsWithLifecycles) ? E._returningProductsWithLifecycles() : 0;
            // CUMULATIVE cap (2026-06-04 fix for ">2 recommendations badged"): this
            // function runs MULTIPLE times per page (run()'s recs-retry loop + the
            // SE_userFlowReady re-badge). The loop's `teased` counter resets to 0 each
            // run while `_badgedHandles` only SKIPS already-badged recs — so each run
            // painted a FRESH teaserBudget worth of NEW recs, accumulating to 2×/3× the
            // cap. Subtract recs already teaser-badged on THIS page so the TOTAL across
            // all runs never exceeds CAP − triggered. (In returning, _badgedHandles holds
            // only teaser recos — best-seller is flow-gated off and the engine's
            // lifecycle reveal uses its own dedup, not _badgedHandles.)
            var alreadyTeased = 0;
            for (var ti = 0; ti < recs.length; ti++) {
                var th = recs[ti] && recs[ti].productLink;
                if (th && _badgedHandles.has(th)) alreadyTeased++;
            }
            var teaserBudget = Math.max(0, CAP - triggered - alreadyTeased);
            if (teaserBudget <= 0) {
                /* diagnostic removed */
                return;
            }
            // The buyer's camo drives WHICH color-specific bundle lights up — so
            // we color-gate the bundle propagation (same precision as the engine's
            // Pass 1). Color = buyer's dominant bought camo → per-product recommended
            // → Multicam default. Slugified to match _extractColorFromBundleHandle.
            var prefs = (E && E._buyerSizeColorPrefs) ? E._buyerSizeColorPrefs() : null;
            var slugifyColor = function (c) {
                return c ? String(c).toLowerCase().replace(/[™®©]/g, '').trim().replace(/\s+/g, '-') : null;
            };
            var teased = 0;
            for (var i = 0; i < recs.length && teased < teaserBudget; i++) {
                var handle = recs[i] && recs[i].productLink;
                if (!handle || _badgedHandles.has(handle)) continue;
                // Skip recs already TRIGGERED (real lifecycle → the engine badges them).
                // Teaser badges go ONLY on not-yet-clicked recs, and create NO lifecycle.
                if (E && E.countActiveLifecyclesForProduct && E.countActiveLifecyclesForProduct(handle) > 0) continue;
                // dead product (workflow ran + ended, no restart possible):
                // no teaser, and it must not burn the teaser budget either
                if (E && typeof E.isProductExhausted === 'function' && E.isProductExhausted(handle)) continue;
                var _camo = (prefs && prefs.color)
                    || (E && E.getRecommendedColor && E.getRecommendedColor(handle))
                    || 'Multicam';
                // SAME "LOW ON STOCK" badge as best-seller (shared path), but
                // COLOR-GATED so only the buyer's-color bundle lights up — not every
                // bundle containing the component. Unit count is PDP-only.
                if (badgeProductWithBundles(handle, (recs[i] && recs[i].sku) || '', slugifyColor(_camo), 'c')) { // 'c' = returning predicted-next reco (neutralized; cae → return_reco)
                    teased++;
                }
            }
            /* diagnostic removed */
        } catch (e) {}
    }

    // Best-seller is a NEW-USER signal; the returning-user flow CANCELS it. The
    // flow gate resolves __userFlow async (after this file's run()), so we defer
    // the best-seller decision until it's known, then activate only for
    // non-returning users. Fires the callback once.
    function _whenFlowKnown(cb) {
        try {
            if (typeof window !== 'undefined' && window.__userFlow) { cb(window.__userFlow); return; }
            var done = false;
            var fire = function () { if (done) return; done = true; cb((typeof window !== 'undefined' && window.__userFlow) || 'new-user'); };
            window.addEventListener('SE_userFlowReady', fire, { once: true });
            setTimeout(fire, 4000);
        } catch (e) { try { cb('new-user'); } catch (e2) {} }
    }

    async function _activateBestSeller(country, collection) {
        try {
            var target = await loadCollectionTarget(country, collection);
            if (!target) return;
            await applyBadgeForTarget(target);
        } catch (e) {}
    }

    // ── orchestration ───────────────────────────────────────────────────
    async function run() {
        var country = readCountry();
        var collection = readCurrentCollection();

        // Collection pages get their OWN best-seller fetched dynamically.
        // This is what makes Combat Gear (and any other un-configured
        // collection) work — and it's what fixes the "only the first-
        // ever-clicked collection's best-seller loads" bug, because the
        // cache key is now (country, collectionId) instead of just country.
        // One badge per collection, on the collection's own grid.
        // RETURNING predicted-next badging runs on EVERY page (collection, search,
        // home, PDP related-rails) so the reco products show their product-level
        // LOW ON STOCK badge wherever their card renders — not only on collection
        // grids (the "/search shows nothing" bug). BEST-SELLER stays collection-only
        // (it's a NEW-USER signal). Deferred until the flow gate resolves; retried
        // until the reco list (recommendations.js) has loaded.
        _whenFlowKnown(function (flow) {
            if (flow === 'returning-user') {
                var tries = 0;
                (function attempt() {
                    var hasRecs = false;
                    try { hasRecs = !!localStorage.getItem('recommendedProducts'); } catch (e) {}
                    if (hasRecs) { _badgeRecommendedForReturning(); return; }
                    if (tries++ < 6) setTimeout(attempt, 700);
                })();
            } else if (collection) {
                _activateBestSeller(country, collection);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }

    // The flow gate (user-flow-gate.js) resolves window.__userFlow AFTER this
    // file's run() (the purchase signal is async), so re-badge predicted-next
    // products when it lands — collection grids only, deduped via _badgedHandles.
    window.addEventListener('SE_userFlowReady', function () {
        try { if (readCurrentCollection()) _badgeRecommendedForReturning(); } catch (e) {}
    });

    // Manual reset for testing.
    window.__resetLowStockCache = function () {
        Object.keys(sessionStorage)
            .filter(function (k) {
                return k.indexOf(TARGETS_KEY_PREFIX) === 0
                    || k.indexOf(COLLECTION_TARGET_KEY_PREFIX) === 0;
            })
            .forEach(function (k) { sessionStorage.removeItem(k); });
        sessionStorage.removeItem(HANDLE_CACHE_KEY);
        _handleCache = {};
        _handlePromises = {};
        localStorage.removeItem(CLICKED_KEY);
        window.__SE_count = 0;
        if (window._AGB_badgedHandles) window._AGB_badgedHandles.clear();
    };
})();
